<template>
    <v-app id="inspire">
        <v-layout row justify-center>
            <v-dialog v-model="onShow" persistent max-width="40%">
                <v-card>
                    <v-card-title>
                        <span class="subheading">MARS - {{getTitle}} system setting: {{ systemSetting.key }}</span>
                    </v-card-title>

                    <v-divider></v-divider>

                    <v-container grid-list-xs style="overflow-y: auto; margin-top: -20px">
                        <v-layout wrap>
                            <v-flex class="modal-flex-height" xs12 sm5>
                                <v-subheader>Key</v-subheader>
                            </v-flex>

                            <v-flex class="modal-flex-height compact-form" xs12 sm7>
                                <v-text-field id="modify_system_setting_key_field"
                                              v-model="systemSetting.key"
                                              name="key"
                                              color="grey darken-2"
                                              :disabled="disabled"
                                              class="text-xs-left"
                                              v-validate="'required:true'"
                                              :error-messages="errors.first('key')"
                                ></v-text-field>
                            </v-flex>


                            <v-flex class="modal-flex-height" xs12 sm5>
                                <v-subheader>Value</v-subheader>
                            </v-flex>

                            <v-flex class="modal-flex-height compact-form" xs12 sm7>
                                <v-text-field
                                        id="modify_system_setting_value_field"
                                        v-model="systemSetting.value"
                                        name="value"
                                        color="grey darken-2"
                                        :disabled="disabled"
                                        class="text-xs-left"
                                        v-validate="'required:true'"
                                        :error-messages="errors.first('value')"
                                ></v-text-field>
                            </v-flex>

                            <v-flex class="modal-flex-height" xs12 sm5>
                                <v-subheader>Description</v-subheader>
                            </v-flex>

                            <v-flex class="modal-flex-height compact-form" xs12 sm7>
                                <v-text-field
                                        id="modify_system_setting_description_field"
                                        v-model="systemSetting.description"
                                        name="description"
                                        color="grey darken-2"
                                        :disabled="disabled"
                                        class="text-xs-left"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>

                    <v-alert :value="error" type="error" transition="scale-transition">
                        {{ errorMessage }}
                    </v-alert>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn id="modify_system_setting_save_button" class="text-none" color="green" small dark
                               @click="onSaveSystemSetting"
                               :disabled="disabled">Save
                        </v-btn>
                        <v-btn id="modify_system_setting_cancel_button" class="text-none" small @click="close">Cancel
                        </v-btn>
                    </v-card-actions>

                </v-card>
            </v-dialog>
        </v-layout>
    </v-app>
</template>

<script>

    import systemsettinginterface from "../../../interfaces/systemsettinginterface";
    import {EventBus} from "../../../eventbus";
    import errormessagemanager from "../../../managers/errormessagemanager";

    export default {
        name: 'ShowSystemSettingModal',

        data: () => ({
            error: false,
            errorMessage: null
        }),

        props: {
            value: Boolean,

            editMode: Boolean,
            disabled: Boolean,

            systemSetting: {
                systemSettingId: Number,
                key: String,
                value: String,
                description: String
            }
        },

        computed: {
            getTitle: function () {
                return this.editMode ? "Edit" : "Create";
            },

            onShow: {
                get() {
                    return this.value
                },
                set(value) {
                    this.$emit('input', value)
                }
            }
        },

        methods: {

            async onSaveSystemSetting() {
                this.clearAlert();

                this.$validator.validateAll().then(async result => {
                    if (result) {
                        let response = null;

                        if (!this.editMode) {
                            await systemsettinginterface.postSystemSetting(this.systemSetting, res => {
                                response = res;
                            });
                        } else {
                            await systemsettinginterface.putSystemSetting(this.systemSetting, res => {
                                response = res;
                            });
                        }

                        if (response != null && response.error) {
                            if (!this.editMode) {
                                errormessagemanager.getInsertErrorMessage(response.status, message => {
                                    this.errorMessage = message;
                                });
                                this.error = response.error;
                            } else {
                                errormessagemanager.getUpdateErrorMessage(response.status, message => {
                                    this.errorMessage = message;
                                });
                                this.error = response.error;
                            }
                        } else if (!this.error) {
                            await EventBus.$emit('refreshSystemSettingList');
                            this.close();
                        }
                    }
                });
            },

            async close() {
                await EventBus.$emit('systemSettingModalClosed');

                this.clearData();
                this.clearAlert();

                this.onShow = false;
            },

            clearData() {
                this.systemSetting.systemSettingId = null;
                this.systemSetting.key = null;
                this.systemSetting.value = null;
                this.systemSetting.description = null;

                this.$validator.errors.clear();
                this.$validator.fields.items.forEach(field => field.reset());
                this.$validator.fields.items.forEach(field => this.errors.remove(field));
                this.$validator.resume();
            },

            clearAlert() {
                this.error = false;
                this.errorMessage = null;
            }
        }
    }
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/settings/modals/ShowSystemSettingModal.vue